import React from 'react';

export const BreadcrumbNavigation = ({ navigationStack, onBreadcrumbClick }) => {
  return (
    <div className="breadcrumb-navigation">
      {navigationStack.map((item, index) => (
        <React.Fragment key={index}>
          <span
            className={`breadcrumb-item ${index === navigationStack.length - 1 ? 'active' : ''}`}
            onClick={() => index < navigationStack.length - 1 && onBreadcrumbClick(index)}
            style={{ cursor: index < navigationStack.length - 1 ? 'pointer' : 'default' }}
          >
            {item.name}
          </span>
          {index < navigationStack.length - 1 && (
            <span className="breadcrumb-separator"> / </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
